"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const body_1 = require("./body");
const col_1 = require("./col");
const head_1 = require("./head");
const row_1 = require("./row");
const CustomTable_module_scss_1 = __importDefault(require("./CustomTable.module.scss"));
const CustomTable = ({ children, className, position = 'none', ...rest }) => {
    const tableClasses = (0, classnames_1.default)(CustomTable_module_scss_1.default.content, className, {
        [CustomTable_module_scss_1.default.frozenColumn]: position === 'sticky'
    });
    return ((0, jsx_runtime_1.jsx)("table", { className: tableClasses, cellSpacing: 0, ...rest, children: children }));
};
CustomTable.Head = head_1.Head;
CustomTable.Body = body_1.Body;
CustomTable.Row = row_1.Row;
CustomTable.Col = col_1.Col;
exports.default = CustomTable;
